module.exports = __webpack_public_path__ + "img/game_main_pc_255_off.b4dd16df.png";